import React from "react";
import { Autocomplete, Checkbox, Chip, TextField } from "@mui/material";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

const SELECT_ALL = "All";

interface MultiSelectWithCheckboxProps {
  options: string[];
  value: string[];
  onChange: (value: string[]) => void;
  label?: string;
  placeholder?: string;
  selectAll?: boolean;
}

export function MultiSelectWithCheckbox({
  options,
  value,
  onChange,
  label,
  placeholder,
  selectAll = true,
}: MultiSelectWithCheckboxProps) {
  const allSelected = options.length > 0 && value.length === options.length;
  const [inputValue, setInputValue] = React.useState("");
  const [focused, setFocused] = React.useState(false);
  const displayOptions = selectAll ? [SELECT_ALL, ...options] : options;

  return (
    <Autocomplete
      multiple
      disableCloseOnSelect
      options={displayOptions}
      value={value}
      inputValue={inputValue}
      onInputChange={(_, newInput) => setInputValue(newInput)}
      ListboxProps={{ style: { maxHeight: 200, overflow: "auto" } }}
      onChange={(_, newValue, __, details) => {
        if (details?.option === SELECT_ALL) {
          onChange(allSelected ? [] : [...options]);
          return;
        }
        const filtered = newValue.filter((v) => v !== SELECT_ALL);
        onChange(filtered);
      }}
      renderOption={(props, option, { selected }) => {
        const isAll = option === SELECT_ALL;
        return (
          <li {...props}>
            <Checkbox
              icon={icon}
              checkedIcon={checkedIcon}
              style={{ marginRight: 8 }}
              checked={isAll ? allSelected : selected}
            />
            {option}
          </li>
        );
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          placeholder={placeholder}
          onFocus={() => setFocused(true)}
          onBlur={() => setFocused(false)}
          InputProps={{
            ...params.InputProps,
            startAdornment: (
              <>
                {value.length === 0 && !focused && inputValue === "" && (
                  <span style={{ marginLeft: 4, color: "rgba(0, 0, 0, 0.6)" }}>
                    All
                  </span>
                )}
                {params.InputProps.startAdornment}
              </>
            ),
          }}
        />
      )}
    />
  );
}
